import { FilterValueListService, FilterValue } from '../filter/types';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDirection } from '@app/core/types/client-pricing-offer';
import { ChangeDirectionTranslationPipe } from '@app/shared/pipes/change-direction-translation.pipe';

@Injectable()
export class ChangeDirectionValueListService implements FilterValueListService {
  constructor(private translateService: TranslateService) { }

  getFilterValues$(): FilterValue[] {
    const changeDirectionTranslationPipe: ChangeDirectionTranslationPipe = new ChangeDirectionTranslationPipe();

    return Object.values(ChangeDirection).map((direction: ChangeDirection): FilterValue => {
      return {
        value: direction,
        displayText: this.translateService.instant(
          changeDirectionTranslationPipe.transform(direction)
        ),
      };
    });
  }
}